<app-auth-form
	[isRegister]="3"
	[showSuccessState]="success"
	(formSubmit)="onSubmit($event)"
></app-auth-form>
